import React from "react"
import { injectIntl } from "react-intl"
import { ProductCustomAttributesComponentProps } from "../../../../../common/types"
import IntlProps from "../../../../../state/helpers/IntlProps"
import ProductCustomAttributeDefintion from "../../../../../state/product-custom-attributes/CustomAttributeDefinition"
import {
    CUSTOM_ATTRIBUTE_TYPE_SELECT,
    CUSTOM_ATTRIBUTE_TYPE_TEXT,
    getShouldDisplayValues,
    INVALID_STATUSES,
    VALID_DOCUMENT_TYPE,
    VALID_DOCUMENT_TYPES
} from "../../../../../utils"
import ProductCustomAttributesImageSelectComponent from "./components/productCustomAttributesImageSelect/ProductCustomAttributesImageSelectComponent"
import ProductCustomAttributesTextInputComponent from "./components/productCustomAttributesTextInput/ProductCustomAttributesTextInputComponent"

const ProductCustomAttributesComponent = (props: ProductCustomAttributesComponentProps & IntlProps) => {
    const productCustomAttributeDefns = props.productCustomAttributeDefns.map(i => new ProductCustomAttributeDefintion(i))
    const isValidStatus = !INVALID_STATUSES.includes(props.documentStatus)
    const isValidDocumentType = VALID_DOCUMENT_TYPES.includes(props.documentType)
    const isEditPriceListTemplate = props.documentType === VALID_DOCUMENT_TYPE.PRICE_LIST && props.isEditTemplateMode
    const isEditable = isValidDocumentType && isValidStatus
    const productCustomDefinitions = productCustomAttributeDefns.map((input, index) => {
        const isRequired = false
        const attributeType = input.getFieldType()
        const allowMoreThanOneChoice = input.allowMoreThanOneChoice()
        const customAttributeDefinitionId = input.getId()
        const metadata = input.getLabel().metadata
        const topLayerLabel = input.getLabel().label || input.getDeprecatedLabel()
        const objIndex = props.itemCustomAttributeValues[props.item.id].findIndex(
            obj => obj.customAttributeDefinitionId === input.getId()
        )
        let customValue = ""
        let selectValue: Array<string> = []
        if (objIndex >= 0) {
            customValue = props.itemCustomAttributeValues[props.item.id][objIndex].textValue || ""
            selectValue = props.itemCustomAttributeValues[props.item.id][objIndex].selectValue || []
        }
        const displayValues = getShouldDisplayValues(props.item, props.choicesSelected, props.optionsSelected)
        const noChoicesSelected = Object.values(props.choicesSelected).every(value => value === false)
        const displayInEditMode = noChoicesSelected || displayValues

        if (attributeType === CUSTOM_ATTRIBUTE_TYPE_TEXT.value) {
            return (
                displayInEditMode && (
                    <ProductCustomAttributesTextInputComponent
                        key={index}
                        customValue={customValue}
                        isEditPriceListTemplate={isEditPriceListTemplate}
                        isEditable={isEditable}
                        itemId={props.item.id}
                        onHandleCustomAttributeChange={props.onHandleCustomAttributeChange}
                        isRequired={isRequired}
                        displayValues={displayValues}
                        label={topLayerLabel}
                        customAttributeDefinitionId={customAttributeDefinitionId}
                        allowMoreThanOneChoice={allowMoreThanOneChoice}
                        hideDivider={(productCustomAttributeDefns || []).length - 1 === index}
                        attributeType={attributeType}
                        isPdf={props.isPdf}
                    />
                )
            )
        }

        if (attributeType === CUSTOM_ATTRIBUTE_TYPE_SELECT.value) {
            return (
                <ProductCustomAttributesImageSelectComponent
                    attributeType={attributeType}
                    key={index}
                    itemId={props.item.id}
                    onHandleCustomAttributeChange={props.onHandleCustomAttributeChange}
                    selectValue={selectValue}
                    isRequired={isRequired}
                    isEditable={isEditable}
                    label={topLayerLabel}
                    customAttributeDefinitionId={customAttributeDefinitionId}
                    allowMoreThanOneChoice={allowMoreThanOneChoice}
                    metadata={metadata}
                    hideDivider={(productCustomAttributeDefns || []).length - 1 === index}
                    isPdf={props.isPdf}
                />
            )
        }
    })
    return <>{productCustomDefinitions}</>
}

export default injectIntl(ProductCustomAttributesComponent)



// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/product-custom-attribute/ProductCustomAttributesComponent.tsx